import request from '@/modules/huyu-framework/backend/utils/request'

// // 获取路由
// export const getRouters = () => {
//   return request({
//     url: '/getRouters',
//     method: 'get'
//   })
// }

// 获取路由

export function getRouters(query) {
  return request({
    url: '/getRouters',
    method: 'get',
    params: query
  })
}